var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M9.07 3.125c1.519 0 2.958.497 4.147 1.4l-2.753 2.592 7.003.751-.33-7.035-2.792 2.63A8.34 8.34 0 0 0 9.07 1.597C4.436 1.597.667 5.367.667 10h1.527A6.88 6.88 0 0 1 9.07 3.125M9.069 16.875a6.82 6.82 0 0 1-4.148-1.4l2.753-2.592-7.003-.751.33 7.035 2.792-2.63a8.34 8.34 0 0 0 5.276 1.866c4.633 0 8.403-3.77 8.403-8.403h-1.528a6.88 6.88 0 0 1-6.875 6.875"
})));
export { SvgRefresh as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh.8656b6b9.svg";